const servicesText = [
  {
    services: "Services",
    servicesText1:
      "Wego transport provides high quality full cargo transportation and storage services:",
    servicesText2: "Full cargo transportation in tent trailers.",
    servicesText3:
      "Full cargo transportation in refrigerator semi-trailers (from -25C to +25 C).",
    servicesText4:
      "Short-term/long term storage and cargo handling services in the Netherlands (Rotterdam).",
    fleet: "Our fleet:",
    frigo: "Frigo trailers",
    frigoCap: "Capacity: up to 22 t",
    frigoDim: "Dimensions of the cargo-space: 13.4 m x 2.7 m",
    curtain: "Curtainsider",
    curtainCap: "Capacity: up to 25 t, 83 – 90 m3",
    curtainDim: "Dimensions of the cargo-space: 13.6 m x 2.7 m",
    mega: "Mega",
    megaCap: "Capacity: up to 22 t, 100 m3",
    megaDim: "Dimensions of the cargo-space: 13.6 m x 2.97 m",
    train: "Road train",
    trainCap: "Capacity: up to 22 t, 117 m3",
    trainDim:
      "Dimensions of the cargo-space: 7.3 m x 3.0 m & 8.2 m x 3.0 m (trailer)",
  },
  {
    services: "Paslaugos",
    servicesText1:
      "Wego transport teikia aukštos kokybės pilnų krovinių gabenimo bei sandėliavimo paslaugas:",
    servicesText2: "Pilnų krovinių gabenimas tentinėmis puspriekabėmis.",
    servicesText3:
      "Pilnų krovinių gabenimas šaldytuvinėmis puspriekabėmis (nuo -25C iki +25C).",
    servicesText4:
      "Trumpalaikio / Ilgalaikio sandėliavimo paslaugos bei krovos darbai Olandijoje (Rotterdame).",
    fleet: "Paslaugas teikiame tokiomis transporto priemonėmis:",
    frigo: "Sunkvežimis su šaldytuvine puspriekabe",
    frigoCap: "Talpa: iki 23 t",
    frigoDim: "Puspriekabės matmenys: 13.4 m x 2.7 m",
    curtain: "Sunkvežimis su tentine (užuolaidine) puspriekabe",
    curtainCap: "Talpa: iki 25 t, 83 – 90 m3",
    curtainDim: "Puspriekabės matmenys: 13.6 m x 2.7 m",
    mega: " Sunkvežimis su mega puspriekabe",
    megaCap: "Talpa: iki 22 t, 100 m3",
    megaDim: "Puspriekabės matmenys: 13.6 m x 2.97 m",
    train: "Autotraukinys",
    trainCap: "Talpa: iki 22 t, 117 m3",
    trainDim: "Puspriekabių matmenys: 7.3 m x 3.0 m ir 8.2 m x 3.0 m",
  },
  {
    services: "Usługi",
    servicesText1:
      "Wego transport świadczy wysokiej jakości usługi transportu oraz magazynowania pełnych ładunków:",
    servicesText2: "Transport pełnych ładunków naczepami plandekowymi.",
    servicesText3:
      "Transport pełnych ładunków naczepami chłodniami (od -25C do +25C).",
    servicesText4:
      "Usługi krótkoterminowego/długoterminowego magazynowania oraz obsługa ładunków w Holandii (Rotterdam).",
    fleet: "Do świadczenia usług używamy następujących pojazdów:",
    frigo: "Naczepy typu Chlodnia",
    frigoCap: "Ładowność: do 23 t",
    frigoDim: "Wymiary naczepy: 13.4 m x 2.7 m",
    curtain: "Naczepy typu Standard",
    curtainCap: "Ładowność: do 25 t, 83 – 90 m3",
    curtainDim: "Wymiary naczepy: 13.6 m x 2.7 m",
    mega: "Naczepy typu Mega",
    megaCap: "Ładowność: do 22 t, 100 m3",
    megaDim: "Wymiary naczepy: 13.6 m x 2.97 m",
    train: " Zestawy plandekowe o ładowności 120 m3",
    trainCap: "Ładowność: do 22 t, 117 m3",
    trainDim: "Wymiary naczep: 7.3 m x 3.0 m i 8.2 m x 3.0 m",
  },
];

export default servicesText;
